<template>
  <Modal title="Create new user" :show="true" @close="$emit('close')" :smallModal="true">
    <div class="form--wrapper">
      <p>You can create new users for your organization's account here</p>

      <div class="form-group">
        <div class="form-group--inside">
          <label for="botName">Name</label>
          <br />
          <input type="username" class="da-input" v-model="name" placeholder="Name" />

          <div v-if="nameInvalid" class="invalid">Please provide a valid name. Name can only have the following characters: _, ., -, a-z, A-Z, 0-9</div>

          <label for="botName">Email</label>
          <br />
          <input type="email" class="da-input" v-model="email" placeholder="Email" />

          <div v-if="emailInvalid" class="invalid">Please provide a valid email.</div>

          <label for="botName">Password</label>
          <br />
          <input type="password" class="da-input" v-model="password" placeholder="Password" />

          <div v-if="passwordInvalid" class="invalid">
            Please provide a valid password. Password must be at least 8 characters long and contain at least one uppercase letter and one special character.
          </div>

          <Toggle label="Send login data to new user" v-model="sendLoginData" />
        </div>
      </div>
    </div>

    <div class="bottom-right-fix">
      <SmallLoading isInverted="true" v-if="loadingIndicator"></SmallLoading>
      <button class="btn btn--purple gradient" type="button" @click="createUser()">
        {{ createUserText }}<i class="icon icon-arrow-right" v-if="!loadingIndicator"></i>
      </button>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Component, Mixins, Watch } from 'vue-property-decorator'
import popupService from '../../../../services/popup.service'
import SmallLoading from '../../../helpers/SmallLoading.vue'
import Modal from '../../../helpers/Modal.vue'
import authManagmentMixin from '../../../auth/auth-managment.mixin'
import Toggle from '../../../helpers/Toggle.vue'
import { validateEmail, validatePassword, validateUserName } from '../../../../../../common/validators/validator'

@Component({ components: { SmallLoading, Modal, Toggle } })
export default class CreateUser extends Mixins(authManagmentMixin) {
  private nameInvalid = false
  private emailInvalid = false
  private passwordInvalid = false
  private name = ''
  private email = ''
  private password = ''
  private loadingIndicator = false
  private createUserText = 'Create User'
  private sendLoginData = true

  validateForm() {
    this.emailInvalid = !validateEmail(this.email)
    this.nameInvalid = !validateUserName(this.name)
    this.passwordInvalid = !validatePassword(this.password)
  }

  private createUser() {
    this.validateForm()

    if (!this.nameInvalid && !this.emailInvalid && !this.passwordInvalid) {
      this.loadingIndicator = true
      this.createUserText = 'Creating...'
      this.$emit('create-user', this.name, this.email, this.password, this.sendLoginData)
    } else {
      popupService.showWarning('Invalid input', 'Please provide a valid name, email and password.')
    }
  }
}
</script>

<style lang="scss" scoped>
.da-input {
  margin-bottom: 10px;
}
</style>
